import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { store } from "../../../../redux-store/store";

const initialFValues = {
  locationId: "",
  tankShortName: "",
  storageTankDescription: "",
  maxVolume: "",
};

export default function AddLocationForm(props) {
  const { addOrEdit, recordForEdit, locations } = props;

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("locationId" in fieldValues)
      temp.locationId = fieldValues.locationId
        ? ""
        : "Location Id is Required.";
    if ("tankShortName" in fieldValues)
      temp.tankShortName = fieldValues.tankShortName
        ? ""
        : "Tank Short Name is Required.";
    if ("storageTankDescription" in fieldValues)
      temp.storageTankDescription = fieldValues.storageTankDescription
        ? ""
        : "Tank Description is Required.";
    if ("maxVolume" in fieldValues)
      temp.maxVolume = fieldValues.maxVolume ? "" : "Max Volume is Required.";

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var result = {
        ...values,
        companyId: store.getState().persistReducer.companyId,
      };
      addOrEdit(result, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  const [holdBtn, setHoldBtn] = useState(true);

  useEffect(() => {
    const allValuesFilled = Object.values(values).every(
      (value) => value !== "" && value !== null && value !== undefined
    );
    if (allValuesFilled) {
      setHoldBtn(false);
    } else {
      setHoldBtn(true);
    }
  }, [values]);
  
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={12}>
          <Controls.Input
            label="Tank Short Name*"
            name="tankShortName"
            value={values.tankShortName || ""}
            onChange={handleInputChange}
            error={errors.tankShortName}
          />
          <Controls.Input
            label="Storage Tank Description*"
            name="storageTankDescription"
            value={values.storageTankDescription || ""}
            onChange={handleInputChange}
            error={errors.storageTankDescription}
          />
          <Controls.Input
            label="Max Volume"
            name="maxVolume"
            value={values.maxVolume || ""}
            onChange={handleInputChange}
            error={errors.maxVolume}
          />
          <div>
            <Controls.Button disabled={holdBtn} type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
